export default class PurchaseCostsCalculator {

    constructor() {
        this.propertySuburb = '';
        this.purchasePrice = 0;
        this.depositSource = 'Cash';
        this.depositAmount = 0;
        this.depositPercentage = 20;
        this.stampDuty = 0;
        this.legalFees = 2000;
        this.prepurchaseInspections = 600;
        this.otherFeesCosts = 0;
        this.totalCalc = 0;
        this.stateTable = ['NSW', 'ACT', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'];
        this.propertyState = '';
    }

    copyOtherPurchaseCostsCalculator(purchaseCostsCalculator) {
        this.propertySuburb = purchaseCostsCalculator.propertySuburb;
        this.purchasePrice = purchaseCostsCalculator.purchasePrice;
        this.depositSource = purchaseCostsCalculator.depositSource;
        this.depositAmount = purchaseCostsCalculator.depositAmount;
        this.depositPercentage = purchaseCostsCalculator.depositPercentage;
        this.stampDuty = purchaseCostsCalculator.stampDuty;
        this.legalFees = purchaseCostsCalculator.legalFees;
        this.prepurchaseInspections = purchaseCostsCalculator.prepurchaseInspections;
        this.otherFeesCosts = purchaseCostsCalculator.otherFeesCosts;
        this.totalCalc = purchaseCostsCalculator.totalCalc;
        this.propertyState = purchaseCostsCalculator.propertyState;
    }

    setPropertySuburb(propertySuburb) {
        this.propertySuburb = propertySuburb;
        this.calcPropertyState();
        this.calcStampDuty();
    }

    getPropertySuburb() {
        return this.propertySuburb;
    }

    getPropertyState() {
        return this.propertyState;
    }

    calcPropertyState() {
        let propertySuburbArray = this.propertySuburb.split(" ");
        this.propertyState = propertySuburbArray[propertySuburbArray.length - 1];
        this.propertyState = this.propertyState.toUpperCase();
    }

    setPurchasePrice(purchasePrice) {
        this.purchasePrice = Number(purchasePrice);
        this.calcDepositAmount();
        this.calcDepositPercentage();
        this.calcStampDuty();
    }

    getPurchasePrice() {
        return this.purchasePrice;
    }

    setDepositSource(depositSource) {

        if (depositSource === 'Cash' || depositSource === 'Equity') {
            this.depositSource = depositSource;
        }
    }

    getDepositSource() {
        return this.depositSource;
    }

    setDepositAmount(depositAmount) {
        this.depositAmount = Number(depositAmount);
        this.calcDepositPercentage();
        this.setTotal();
    }

    getDepositAmount() {
        return this.depositAmount;
    }

    calcDepositAmount() {
        if (this.purchasePrice !== 0) {
            this.depositAmount = (this.purchasePrice * this.depositPercentage) / 100;
        }
    }

    setDepositPercentage(depositPercentage) {
        this.depositPercentage = Number(depositPercentage);
        this.calcDepositAmount();
        this.setTotal();
    }

    getDepositPercentage() {
        return this.depositPercentage;
    }

    calcDepositPercentage() {
        if (this.purchasePrice !== 0) {
            this.depositPercentage = this.depositAmount * 100 / this.purchasePrice;
        }
    }

    setStampDuty(stampDuty) {
        this.stampDuty = Number(stampDuty);
        this.setTotal();
    }

    getStampDuty() {
        this.setTotal();
        return this.stampDuty;
    }

    calcStampDuty() {

        if (this.propertyState === 'NSW') {
            if (this.purchasePrice <= 14000) {
                this.stampDuty = Math.ceil(this.purchasePrice / 100) * 1.25;
            } else if (this.purchasePrice <= 30000) {
                this.stampDuty = 175 + Math.ceil((this.purchasePrice - 14000) / 100) * 1.50;
            } else if (this.purchasePrice <= 80000) {
                this.stampDuty = 415 + Math.ceil((this.purchasePrice - 30000) / 100) * 1.75;
            } else if (this.purchasePrice <= 300000) {
                this.stampDuty = 1290 + Math.ceil((this.purchasePrice - 80000) / 100) * 3.50;
            } else if (this.purchasePrice <= 1000000) {
                this.stampDuty = 8990 + Math.ceil((this.purchasePrice - 300000) / 100) * 4.50;
            } else if (this.purchasePrice <= 3000000) {
                this.stampDuty = 40490 + Math.ceil((this.purchasePrice - 1000000) / 100) * 5.50;
            } else if (this.purchasePrice > 3000000) {
                this.stampDuty = 70000 + Math.ceil((this.purchasePrice - 3000000) / 100) * 7.00;
            }

            if (Math.floor(this.stampDuty) !== this.stampDuty) {
                this.stampDuty = Math.round(this.stampDuty);
            }

            this.setTotal();
        } else if (this.propertyState === 'ACT') {
            if (this.purchasePrice <= 200000) {
                if (Math.floor(this.purchasePrice / 100) * 1.48 > 20) {
                    this.stampDuty = Math.ceil(this.purchasePrice / 100) * 1.48;
                } else {
                    this.stampDuty = 20;
                }

            } else if (this.purchasePrice <= 300000) {
                this.stampDuty = 2960 + Math.ceil((this.purchasePrice - 200000) / 100) * 2.50;
            } else if (this.purchasePrice <= 500000) {
                this.stampDuty = 5460 + Math.ceil((this.purchasePrice - 300000) / 100) * 4.00;
            } else if (this.purchasePrice <= 750000) {
                this.stampDuty = 13460 + Math.ceil((this.purchasePrice - 500000) / 100) * 5.50;
            } else if (this.purchasePrice <= 1000000) {
                this.stampDuty = 25960 + Math.ceil((this.purchasePrice - 750000) / 100) * 6.50;
            } else if (this.purchasePrice <= 1455000) {
                this.stampDuty = 42210 + Math.ceil((this.purchasePrice - 1000000) / 100) * 7.00;
            } else if (this.purchasePrice > 1455000) {
                this.stampDuty = Math.floor(this.purchasePrice / 100) * 5.09;
            }

            if (Math.floor(this.stampDuty) !== this.stampDuty) {
                this.stampDuty = Math.round(this.stampDuty);
            }

            this.setTotal();
        } else if (this.propertyState === 'NT') {
            if (this.purchasePrice <= 525000) {
                this.stampDuty = (0.06571441 * (this.purchasePrice/1000) * (this.purchasePrice/1000))
                    + 15 * (this.purchasePrice/1000);
            } else if (this.purchasePrice <= 3000000) {
                this.stampDuty = this.purchasePrice * (4.95 / 100);
            } else if (this.purchasePrice > 3000000) {
                this.stampDuty = this.purchasePrice * (5.45 / 100);
            }

            if (Math.floor(this.stampDuty) !== this.stampDuty) {
                this.stampDuty = Math.round(this.stampDuty);
            }

            this.setTotal();
        } else if (this.propertyState === 'QLD') {
            if (this.purchasePrice <= 5000) {
                this.stampDuty = 0;
            } else if (this.purchasePrice <= 75000) {
                this.stampDuty = Math.ceil((this.purchasePrice - 5000) / 100) * 1.50;
            } else if (this.purchasePrice <= 540000) {
                this.stampDuty = 1050 + Math.ceil((this.purchasePrice - 75000) / 100) * 3.50;
            } else if (this.purchasePrice <= 1000000) {
                this.stampDuty = 17325 + Math.ceil((this.purchasePrice - 540000) / 100) * 4.50;
            } else if (this.purchasePrice > 1000000) {
                this.stampDuty = 38025 + Math.ceil((this.purchasePrice - 1000000) / 100) * 5.75;
            }

            if (Math.floor(this.stampDuty) !== this.stampDuty) {
                this.stampDuty = Math.round(this.stampDuty);
            }

            this.setTotal();
        } else if (this.propertyState === 'SA') {
            if (this.purchasePrice <= 12000) {
                this.stampDuty = Math.ceil(this.purchasePrice / 100) * 1.00;
            } else if (this.purchasePrice <= 30000) {
                this.stampDuty = 120 + Math.ceil((this.purchasePrice - 12000) / 100) * 2.0;
            } else if (this.purchasePrice <= 50000) {
                this.stampDuty = 480 + Math.ceil((this.purchasePrice - 30000) / 100) * 3.00;
            } else if (this.purchasePrice <= 100000) {
                this.stampDuty = 1080 + Math.ceil((this.purchasePrice - 50000) / 100) * 3.50;
            } else if (this.purchasePrice <= 200000) {
                this.stampDuty = 2830 + Math.ceil((this.purchasePrice - 100000) / 100) * 4.00;
            } else if (this.purchasePrice <= 250000) {
                this.stampDuty = 6830 + Math.ceil((this.purchasePrice - 200000) / 100) * 4.25;
            } else if (this.purchasePrice <= 300000) {
                this.stampDuty = 8955 + Math.ceil((this.purchasePrice - 250000) / 100) * 4.75;
            } else if (this.purchasePrice <= 500000) {
                this.stampDuty = 11330 + Math.ceil((this.purchasePrice - 300000) / 100) * 5.00;
            } else if (this.purchasePrice > 500000) {
                this.stampDuty = 21330 + Math.ceil((this.purchasePrice - 500000) / 100) * 5.50;
            }

            if (Math.floor(this.stampDuty) !== this.stampDuty) {
                this.stampDuty = Math.round(this.stampDuty);
            }

            this.setTotal();
        } else if (this.propertyState === 'TAS') {
            if (this.purchasePrice <= 3000) {
                this.stampDuty = 50
            } else if (this.purchasePrice <= 25000) {
                this.stampDuty = 50 + Math.ceil((this.purchasePrice - 3000) / 100) * 1.75;
            } else if (this.purchasePrice <= 75000) {
                this.stampDuty = 435 + Math.ceil((this.purchasePrice - 25000) / 100) * 2.25;
            } else if (this.purchasePrice <= 200000) {
                this.stampDuty = 1560 + Math.ceil((this.purchasePrice - 75000) / 100) * 3.50;
            } else if (this.purchasePrice <= 375000) {
                this.stampDuty = 5935 + Math.ceil((this.purchasePrice - 200000) / 100) * 4.00;
            } else if (this.purchasePrice <= 725000) {
                this.stampDuty = 12935 + Math.ceil((this.purchasePrice - 375000) / 100) * 4.25;
            } else if (this.purchasePrice > 725000) {
                this.stampDuty = 27810 + Math.ceil((this.purchasePrice - 725000) / 100) * 4.50;
            }

            if (Math.floor(this.stampDuty) !== this.stampDuty) {
                this.stampDuty = Math.round(this.stampDuty);
            }

            this.setTotal();
        } else if (this.propertyState === 'VIC') {
            if (this.purchasePrice <= 25000) {
                this.stampDuty = this.purchasePrice * 1.40 / 100
            } else if (this.purchasePrice <= 130000) {
                this.stampDuty = 350 + (this.purchasePrice - 25000) * 2.40 / 100
            } else if (this.purchasePrice <= 960000) {
                this.stampDuty = 2870 + (this.purchasePrice - 130000) * 2.40 / 100
            } else if (this.purchasePrice > 960000) {
                this.stampDuty = this.purchasePrice * 5.50 / 100
            }

            if (Math.floor(this.stampDuty) !== this.stampDuty) {
                this.stampDuty = Math.round(this.stampDuty);
            }

            this.setTotal();
        } else if (this.propertyState === 'WA') {
            if (this.purchasePrice <= 120000) {
                this.stampDuty = Math.ceil(this.purchasePrice / 100) * 1.90;
            } else if (this.purchasePrice <= 150000) {
                this.stampDuty = 2280 + Math.ceil(this.purchasePrice / 100) * 2.85;
            } else if (this.purchasePrice <= 360000) {
                this.stampDuty = 3135 + Math.ceil(this.purchasePrice / 100) * 3.80;
            } else if (this.purchasePrice <= 725000) {
                this.stampDuty = 11115 + Math.ceil(this.purchasePrice / 100) * 4.75;
            } else if (this.purchasePrice > 725000) {
                this.stampDuty = 28453 + Math.ceil(this.purchasePrice / 100) * 5.15;
            }

            if (Math.floor(this.stampDuty) !== this.stampDuty) {
                this.stampDuty = Math.round(this.stampDuty);
            }

            this.setTotal();
        } else {
            this.stampDuty = 0;
        }
    }

    setLegalFees(legalFees) {
        this.legalFees = Number(legalFees);
        this.setTotal();
    }

    getLegalFees() {
        this.setTotal();
        return this.legalFees;
    }

    setPrepurchaseInspections(prepurchaseInspections) {
        this.prepurchaseInspections = Number(prepurchaseInspections);
        this.setTotal();
    }

    getPrepurchaseInspections(){
        this.setTotal();
        return this.prepurchaseInspections;
    }

    setOtherFeesCosts(otherFeesCosts) {
        this.otherFeesCosts = Number(otherFeesCosts);
        this.setTotal();
    }

    getOtherFeesCosts(){
        this.setTotal();
        return this.otherFeesCosts;
    }

    setTotal() {
        this.totalCalc = this.depositAmount + this.stampDuty +
            this.legalFees + this.prepurchaseInspections + this.otherFeesCosts;
    }

    getTotal(){
        return this.totalCalc;
    }

}


// WEBPACK FOOTER //
// ./src/Classes/PurchaseCostsCalculator.js